/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { contractDocumentsControllerCreate } from "./contractDocumentsControllerCreate";
import { contractDocumentsControllerFindAll } from "./contractDocumentsControllerFindAll";
import { contractDocumentsControllerFindOne } from "./contractDocumentsControllerFindOne";
import { contractDocumentsControllerRemove } from "./contractDocumentsControllerRemove";
import { contractDocumentsControllerUpdate } from "./contractDocumentsControllerUpdate";

export function contractDocumentsService() {
  return { contractDocumentsControllerCreate, contractDocumentsControllerFindAll, contractDocumentsControllerFindOne, contractDocumentsControllerUpdate, contractDocumentsControllerRemove }
}